module.exports = __webpack_public_path__ + "img/pendingorder.a288b87a.png";